import {Break} from '@alanngo/custom-components/dist/';
import React from 'react';
import { Button, Card, CardGroup } from 'react-bootstrap'
import { ABOUT } from './logic';
const About = () =>
(
	<div align="center">
		<CardGroup>
			{
				Object.keys(ABOUT).map(elem =>
				(
						<Card bg="light" key={ABOUT[elem].id}>
							<Card.Header as="h5">{ABOUT[elem].name}</Card.Header>
							<Card.Body>
								<img align="top" src={ABOUT[elem].img} width={'200'} alt={elem.id} />
								<Break number={2}/>
								<Card.Text>{ABOUT[elem].desc}</Card.Text>
								<Button variant="dark" href={ABOUT[elem].gh}>Github</Button>
								<Button variant="primary" href={ABOUT[elem].linkedin}>Linkedin</Button>
							</Card.Body>
						</Card>
					)
				)
			}
		</CardGroup>
	</div>
)


export default About;
